import { useEffect, useState } from "react";
import { Box, TextField, Button, IconButton } from "@mui/material";
import { Editor } from "@monaco-editor/react";
import {
  CreateRunjsSetting,
  EditRunjsSetting,
  getRunjsData,
} from "../../Services/ExperienceApi";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as ArrowbackIcon } from "../../Assets/arrowback.svg";
import Grid from "@mui/material/Grid2";

function EditRunJs() {
  const [code, setCode] = useState("");
  const [title, setTitle] = useState("Run JS");
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const fullRunjsId = location.state?.data.id;
  const runjsId = fullRunjsId?.split("_")[1];
  const sessionData = sessionStorage.getItem("pendingNodeAddition");
  const sessionObj = sessionData ? JSON.parse(sessionData) : {};
  const experienceId =
    location.state?.data.experinceId || sessionObj.experinceId;
  const fullSegmentId = location.state?.data.segmentId || sessionObj.segmentId;
  const meterValueId =
    location.state?.data.meter_value_id || sessionObj.meterValueId;
  const segmentId = location.state?.data.segmentId
    ? fullSegmentId.split("_")[1]
    : fullSegmentId;
  const [titleError, setTitleError] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchExperience = async () => {
      if (segmentId && experienceId && runjsId) {
        const response = await getRunjsData(experienceId, segmentId, runjsId);
        if (response.success === true && response) {
          const runjsData = response.runJsSettings[0];
          setTitle(runjsData.title);
          setCode(runjsData.javascript_code);
        }
      }
    };
    fetchExperience();
  }, [segmentId, experienceId, runjsId]);
  const handleSave = async () => {
    if (!title.trim()) {
      setTitleError(true);
      return;
    }
    try {
      setLoading(true);
      const nodeType = sessionStorage.getItem("nodeType");
      const payload: any = {
        title: title,
        javascript_code: code,
      };
      if (nodeType === "paywall") {
        payload.meter_value_id = meterValueId;
      }
      let response;
      if (runjsId) {
        response = await EditRunjsSetting(
          experienceId,
          segmentId,
          runjsId,
          payload
        );
      } else {
        response = await CreateRunjsSetting(experienceId, segmentId, payload);
      }
      if (response.success === true) {
        toast.success(response.message);
        navigate(-1);
      } else {
        toast.error(response.error);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };
  const onback = () => {
    navigate(`/edit-experience/${experienceId}`);
  };
  return (
    <div className="templates">
      <Grid container className="templates__header">
        <Grid
          size={{ xs: 12, md: 6, sm: 6 }}
          className="templates__header--search"
        >
          <div className="d-center">
            <span className="Icon">
              <IconButton aria-label="close" onClick={onback}>
                <ArrowbackIcon />
              </IconButton>{" "}
            </span>{" "}
            <h2 className="mb-0">
              {" "}
              Run JS - Execute a custom JS method or script on the page
            </h2>
          </div>
        </Grid>
        <Grid
          size={{ xs: 12, md: 6, sm: 6 }}
          className="templates__header--button "
        >
          <Box className="button-heading">
            <Button
              className="button"
              sx={{
                "--variant-containedBg": "rgba(228, 0, 43, 1)",
                "&:hover": {
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="contained"
              color="error"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? <span className="loader" /> : "Save"}
            </Button>
            <Button
              sx={{
                "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                "--variant-outlinedColor": "rgba(228, 0, 43, 1)",
                "--variant-containedBg": "rgba(228, 0, 43, 1)",

                "&:hover": {
                  "--variant-outlinedBorder": "rgba(228, 0, 43, 1)",
                  "--variant-outlinedBg": "rgba(228, 0, 43, 0.04)",
                  "--variant-containedBg": "rgba(228, 0, 43, 1)",
                  "--variant-textBg": "rgba(228, 0, 43, 0.04)",
                },
              }}
              variant="outlined"
              onClick={onback}
            >
              Cancel
            </Button>
          </Box>
        </Grid>
      </Grid>

      {/* Card Title Input */}
      <Box className="editSegment__container" mt={2}>
        <Grid container spacing={{ xs: 0, sm: 0, md: 2 }} alignItems={"center"}>
          <Grid size={{ xs: 12, md: 2, sm: 4 }}>
            <div className="editSegment__container--heading">
              <h2>TITLE OF CARD :</h2>
            </div>
          </Grid>
          <Grid
            size={{ xs: 12, md: 8, sm: 8 }}
            className="editSegment__container--heading"
          >
            <TextField
              variant="standard"
              fullWidth
              required
              value={title}
              error={titleError}
              helperText={titleError ? "Title is required" : ""}
              onChange={(e) => {
                const value = e.target.value;
                setTitle(value);
                if (value.trim()) {
                  setTitleError(false); // clear error if input becomes valid
                }
              }}
            />
          </Grid>
        </Grid>
      </Box>

      {/* Properties Section */}
      <Box className="editSegment__container" p={2}>
        <h4>PROPERTIES</h4>

        <Box
          className="editSegment__container--heading "
          sx={{
            border: "1px solid rgba(212, 212, 212, 1)",
            borderBottom: "none",
          }}
          mt={2}
          p={1}
          display={"inline-block"}
        >
          <h2>Javascript code</h2>
        </Box>
        <Box sx={{ border: "1px solid rgba(212, 212, 212, 1)" }} mb={2}>
          <Editor
            height="300px"
            defaultLanguage="html"
            theme="default"
            value={code}
            onChange={(newValue) => setCode(newValue || "")}
            options={{
              minimap: {
                enabled: false,
              },
            }}
          />
        </Box>
        <ToastContainer position="top-right" autoClose={3000} />
      </Box>
    </div>
  );
}

export default EditRunJs;
